
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom';
import { animations } from './lib/utils';

// Initialize animation utilities globally for reusability across components
window.brainWaveAnimations = {
  getRandomDelay: () => animations.randomDelay(),
  getRandomDuration: (min = 1, max = 3) => animations.randomDuration(min, max),
  getRandomColor: () => animations.randomColor()
};

// Implement performance monitoring
if (import.meta.env.PROD) {
  // Report web vitals
  const reportWebVitals = async () => {
    if ('performance' in window && 'getEntriesByType' in window.performance) {
      window.addEventListener('load', () => {
        setTimeout(() => {
          const paintMetrics = performance.getEntriesByType('paint');
          const navigationTiming = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
          const loadTime = navigationTiming.loadEventEnd - navigationTiming.loadEventStart;
          
          console.log('Performance metrics:', {
            loadTime,
            paintMetrics,
            domContentLoaded: navigationTiming.domContentLoadedEventEnd - navigationTiming.domContentLoadedEventStart,
          });
          
          // Here you could send these metrics to your analytics service
        }, 0);
      });
    }
  };
  
  reportWebVitals();

  // Register service worker for production environment
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
}

// Check for browser support of native lazy loading
document.addEventListener('DOMContentLoaded', () => {
  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.setAttribute('loading', 'lazy');
    });
  } else {
    // Consider importing a lazy loading polyfill here
    console.log('Browser does not support native lazy loading');
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
